import React, { Component } from "react";
import { connect } from "react-redux";
import { createAction } from "../../utils";
import { withRouter } from "react-router-dom";

const defaultRedirectTo = "/home"

@connect(({ users }) => ({ ...users }))
class Login extends Component {
  componentDidMount() {
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    const code = params.get("token");
    const redirectTo = params.get("redirect_to") || defaultRedirectTo;
    const isEventRegister = params.get("is_event_register") === "true";
    const verifyCredential = params.get("verify_credential");
    const countryCode = params.get("country_code");
    const mobile = params.get("mobile");
    const email = params.get("email");

    if (isEventRegister) {
      this.props.dispatch({
        type: 'users/updateState',
        payload: {
          eventRegistrationData: {
            verifyCredential,
            countryCode,
            phoneNumber: mobile,
            email,
            ignoreLogin: true,
          },
        }
      });
    }
    if (code) {
      // this.props.cookies.remove('user')
      console.log(code);
      this.props.dispatch(createAction("users/login")({
        code,
        successAction: () => {
          this.props.history.push(redirectTo, { backToHome: true });
        },
        failAction: () => {
          this.props.history.push(defaultRedirectTo);
        }
      }));
    } else {
      if (redirectTo) {
        this.props.history.push(redirectTo, { backToHome: true });
        return
      }
      this.props.history.push(defaultRedirectTo);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.history.push(defaultRedirectTo);
    }
  }

  render() {
    return (
      <div>
        {/* <pre id="content">
                    loading..
                </pre> */}
      </div>
    );
  }
}

export default withRouter(Login);
